<template>
  <div class="main col-sm-12">
    <card class="col-sm-12">
      <div slot="header" class='toolsBar'>
        <div class="leftTools" />
        <div>
          <l-button type="info" @click="handlenew()" class='text-right'>新增</l-button>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column prop="storeId" :formatter="getStoreText" label="商店" />
            <el-table-column prop="name" label="名稱" />
            <el-table-column label="縮圖">
              <div class='imageCol' slot-scope="props">
                <img v-bind:src="props.row.picUrl" />
              </div>
            </el-table-column>
            <el-table-column width="150px" label="貨號">
              <div slot-scope="props">
                <b class="font-weight-light">{{getGoodsNumber(props.row)}}</b>
              </div>
            </el-table-column>
            <el-table-column label="排序">
              <div slot-scope="props">
                <b class="font-weight-light">{{props.row.sort}}</b>
              </div>
            </el-table-column>
            <el-table-column label="狀態">
              <div slot-scope="props">
                <b >{{getStatusText(props.row)}}</b>
              </div>
            </el-table-column>
            <el-table-column prop="price" label="價格" />
            <!-- <el-table-column prop="status" label="備註" /> -->
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs" @click="handleEdit(props.row)">
                  <i class="fa fa-edit" />
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="">
          <p class="card-category" />
        </div>
        <l-pagination class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      @input='handleIndexChange'
                      :total="pagination.total" />
      </div>
      <el-dialog
        center
        class="col-12"
        :title="getTitle()"
        :visible.sync="modals.custom">
        <div class='main'>
          <div class='col-sm-7'>
            <div class="form-group align-left row">
              <label class='col-md-5 col-12'>商店 *</label>
              <div class='col-md-7 col-12 row main'>
                <el-select class="select-default" data-vv-as="商店" placeholder="請選擇" name="storeId" v-model="form.storeId" :error="getError('storeId')"  v-validate="'required'" >
                    <el-option v-for="i in stores" class="select-default" :value="i.id" :label="i.name" :key="i.id" />
                </el-select>
              </div>
              <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('storeId')">{{ errors.first('storeId') }}</div>
            </div>
            <fg-input label="名稱"
                    type="text"
                    name="name"
                    class='row'
                    labelClasses="col-md-5 col-12"
                    inputClasses="col-md-7 col-12"
                    data-vv-as="名稱"
                    v-model="form.name"
                    v-validate="'required'"    
                    :error="getError('name')"
                    required />
          <fg-input label="商店標題"
                    type="text"
                    name="title"
                    class='row'
                    labelClasses="col-md-5 col-12"
                    inputClasses="col-md-7 col-12"
                    data-vv-as="商店標題"
                    v-model="form.title"
                    v-validate="'required'"    
                    :error="getError('title')"
                    required />
          <fg-input label="貨號"
                    type="text"
                    name="goodsNumber"
                    class='row'
                    labelClasses="col-md-5 col-12"
                    inputClasses="col-md-7 col-12"
                    data-vv-as="貨號"
                    v-model="form.goodsNumber"        
                    :error="getError('goodsNumber')" />
          <fg-input label="價格"
                    type="text"
                    name="price"
                    class='row'
                    labelClasses="col-md-5 col-12"
                    inputClasses="col-md-7 col-12"
                    data-vv-as="價格"
                    v-model="form.price"  
                    :error="getError('price')" />
          <div class="form-group align-left row">
            <label class='col-md-5 col-12'>排序 *</label>
            <div class='col-md-7 col-12 row main'>
              <el-select class="select-default" data-vv-as="排序" placeholder="請選擇" name="sort" v-model="form.sort" :error="getError('sort')"  v-validate="'required'" >
                  <el-option v-for="i in Array(8).keys()" class="select-default" :value="i + 1" :label="i + 1" :key="i" />
              </el-select>
            </div>
            <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('storeId')">{{ errors.first('storeId') }}</div>
          </div>
          <div class="form-group align-left">
            <label>狀態</label>
              <div>
                <l-switch v-model="form.status"  on-text="ON" off-text="OFF" />
              </div>
            </div>
          </div>
          <div class='col-sm-5'>
            <div class="align-right">
              <div>
                <label>商品圖片</label>
                <input type='file' @change="(event) => { imgUpload(event, 'picUrl') }" />
                <img src="static/img/default-image.jpg" v-show="(form.picUrl == null || form.picUrl =='')" width='200px' />
                <img v-bind:src="form.picUrl" v-show="form.picUrl !==''" width='200px' />
              </div>
              <div>
                <label>銷售圖片</label>
                <input type='file' @change="(event) => { imgUpload(event, 'salePicUrl') }" />
                <img src="static/img/default-image.jpg" v-show="(form.salePicUrl == null || form.salePicUrl =='')" width='200px' />
                <img v-bind:src="form.salePicUrl" v-show="form.salePicUrl !==''" width='200px' />
              </div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
        </div>
      </el-dialog>
    </card>
  </div>
</template>


<script>
 /* eslint-disable */
  import { DatePicker, Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import LSwitch from 'src/components/Switch.vue'
  import { Checkbox } from 'src/components/index'
  import { Pagination as LPagination } from 'src/components/index'
  import lib from '../../../lib'
  import tools from '../../../tools'

  export default {
    props: ['saleGroup'],
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox,
      [DatePicker.name]: DatePicker,
      LPagination,
      LSwitch,
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        form:{
          id: '',
          name: '',
          picUrl: '',
          storeId: '',
          title: '',
          goodsNumber: '',
          price:'',
          salePicUrl: '',
          sort: '',
          status: 1
        },
        searchForm:{
        },
        query: {
        },
        image: {
          picUrl: null,
          salePicUrl: null,
        },
        stores:[],
        modals: {
          custom: false
        },
        tableData: []
      }
    },
   async mounted() {
      await this.getStores()
      await this.getData()
      
    },
    created() {
      var _this = this
      this.$validator.extend('checkWebType', {
          getMessage: '至少選擇一種',
          validate: (value) => {
            return (_this.form.isOnePage || _this.form.isOfficial) 
          }
      });
    },
    destroyed() {
      this.$parent.$parent.setSubName('');
    },
    watch: {
      'pagination.currentPage': async function(val) {
      }
    },
    computed: {

    },
    methods: {
      getStoreText(row, idx) {
        var storeId = row.storeId
        for (var i=0 ; i < this.stores.length ; i++) {
          if (this.stores[i]['id'] == storeId) {
            return this.stores[i]['name']
          }
        }
        return ''
      },
      getGoodsNumber(row) {
        var goods = row.goods
        if (goods) return goods.goodsNumber
        return ''
      },
      getStatusText(row) {
        return (row.status) ? '啟用' : '停用'
      },
      getTitle() {
        return (this.form.id == '')?'新增加購商品':'編輯加購商品'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return
          _this.createAndUpdate()
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      handleNewStuff() {
        this.$refs.stuff.handlenew()
      },
      handleNewPlan() {
        this.$refs.plan.handlenew()
      },
      imgUpload(event, fileType) {
        var _this = this
        const file = event.target.files.item(0);
        const reader = new FileReader();
        reader.addEventListener("load", function() {
          _this.form[fileType] = reader.result;
          _this.image[fileType] = file
          event.target.value = ''
        }, false);
        reader.readAsDataURL(file);
      },
      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },
      handleEdit(row) {
        this.form.id = row.id
        this.form.name = row.name
        this.form.picUrl = row.picUrl
        this.form.salePicUrl = row.salePicUrl
        this.form.storeId = row.storeId
        this.form.title = row.title
        this.form.price = row.price
        
        this.form.goodsNumber = row.goods.goodsNumber
        this.form.sort = row.sort
        this.form.status = row.status
        this.openModal('custom')
      },
      async getStores() {
        var data = await lib.getStoreList({ offset:0, limit:10 })
        if (data.status == 0) {
          var result = data.result
          this.stores = result.stores
        }
      },
      async handleIndexChange(page) {
        await this.getData()
      },
      async getData() {
        this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        this.query.limit = this.pagination.perPage
        var data = await lib.getAddpurchaseList(this.query)
        if (data.status == 0) {
          var result = data.result
          this.pagination.total = result.count
          this.tableData = result.addPurchases
        }
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
            _this.form.id = ''
            _this.form.picUrl = ''
            _this.form.salePicUrl = ''
            _this.form.storeId = ''
            _this.form.title = ''
            _this.form.name = ''
            _this.form.price = ''
            _this.form.goodsNumber = ''
            _this.form.status = 1
          resolve()
        })
      },
      async uploadImage(file) {
        var data = await lib.uploadImage('addpurchase', file)
        if (data.status == 0) {
          return data.result.picUrl
        } else {
          return ''
        } 
      },
      async createAndUpdate() {
        if (this.image.picUrl) {
           var image = await this.uploadImage(this.image.picUrl)
           if (image == '') {
              this.$swal('上傳圖片失敗', '', 'error')
              return
           }  
           this.form.picUrl = image
           this.image.picUrl = null
        }
        if (this.image.salePicUrl) {
           var image = await this.uploadImage(this.image.salePicUrl)
           if (image == '') {
              this.$swal('上傳圖片失敗', '', 'error')
              return
           }  
           this.form.salePicUrl = image
           this.image.salePicUrl = null
        }
        var actionText = ''
        if (this.form.id === '') {
          var data = await lib.createAddpurchase(this.form)
          actionText = '新增'
        } else {
          var data = await lib.updateAddpurchase(this.form.id, this.form);
          actionText = '更新'
        }
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal(`已${actionText}`, '', 'success')
        } else if (data.status == 112) {
          this.$swal('貨號不存在', '', 'error')
        } else {
          this.$swal(`${actionText}失敗`, '', 'error')
        }
      },
      async handleDelete(id, prop) {
        var result = await tools.confirmDialog(this, "確定要刪除?")
        if (result) {
          var data = await lib.deleteItem(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    }
  }
</script>


<style>

.main {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}

.leftTools > * {
  padding-right: 10px;
}

.rightBtn {
  display: flex;
  justify-content: space-between;
}

</style>
